import { Typography, Box, Stack } from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import { mapModifiers, rem } from "utils";

export interface Props {
  withBreadcrumbs?: boolean;
}

export const PageContainerSkeleton: React.FC<Props> = ({ withBreadcrumbs }) => {
  return (
    <div
      className={mapModifiers(
        "O-PageContainerSkeleton",
        withBreadcrumbs && "WithBreadcrumbs"
      )}
    >
      {withBreadcrumbs && (
        <div className="O-PageContainerSkeleton_Header">
          <Skeleton height={21} />
        </div>
      )}
      <div className="O-PageContainerSkeleton_Body">
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          paddingBottom={rem(16)}
        >
          <Typography variant="h6" component="h2">
            <Skeleton width={100} />
          </Typography>
          <Stack direction="row" spacing={rem(8)}>
            <Skeleton width={105} height={38.97} />
            <Skeleton width={105} height={38.97} />
          </Stack>
        </Box>
        <Skeleton width="100%" height={1} />
        <Box marginTop={rem(16)} flex="1">
          <Skeleton width="100%" height="100%" />
        </Box>
      </div>
    </div>
  );
};
